import { Injectable } from '@angular/core';
import { GameRatingData } from '@features/games/models/game-rating-data';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable()
export class GameRatingService {

  private gameRatingListSubject$ = new BehaviorSubject<GameRatingData[] | undefined>(undefined);
  private ratingChangedSubject$ = new Subject<GameRatingData>();
  
  public get gameRatingList$() : Observable<GameRatingData[] | undefined> {
    return this.gameRatingListSubject$.asObservable();
  }
  public get ratingChange$() : Observable<GameRatingData> {
    return this.ratingChangedSubject$.asObservable();
  }
  
  constructor() { }

  public setRatingList(gameRatingList: GameRatingData[]) {
    this.gameRatingListSubject$.next(gameRatingList);
  }

  public setRating(gameRating: GameRatingData) {
    this.ratingChangedSubject$.next(gameRating);
  }

}
